import tasks from "../components/tasks.vue";

Vue.component("dashboard", {
    props: ["user", "team"],
    components: {
        tasks: tasks
    },
    data: function() {
        return {
            team: {},
            balance: 0
        };
    },
    mounted() {
       this.getTeam();
    },
    methods: {
        getTeam(){
            axios.get("/team", {}).then(response => {
                console.log((response.data));
                this.team = response.data.current_team;
                this.balance = response.data.balance;

            });


        },
    }
});
